import { ENUM__page_type } from '@/enums/ENUM__page_type';
import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';
import { ENUM__user_role } from '@shared/dto/+user/entity/ENUM__user_role';
import { DTO__user_settings } from '@shared/dto/+user/user_settings/DTO__user_settings';
import { DTOUserTutorialProgress } from '@shared/dto/+user/user_tutorial/dto_tutorial_progress';
import { StateUser } from './state_user';

export const slice_user_initial_state: StateUser = {
  auth_token: '',

  user_role: ENUM__user_role.GUEST,

  user_id: '',
  user_full_name: '',
  user_url_relative_avatar: '',
  user_email: '',

  google_email: '',
  microsoft_email: '',
  github_email: '',
  facebook_email: '',
  discord_email: '',

  user_settings: DTO__user_settings.CLIENT_DEFAULT.clone(),

  tutorial_progress: DTOUserTutorialProgress.CREATE_STUB(),

  user_number: CONSTANTS__shared.NUMBER_EMPTY_VALUE,

  is_password_set: false,
  is_authorized: false,

  open_page_after_auth: ENUM__page_type.GENERATION_WITHOUT_PARAMS,
};
